export default "__VITE_ASSET__CDn_UGei__"